import { computed, ref } from "vue";
const globalComponentGraphVersionPrivate = ref(0);
export const globalComponentGraphVersion = computed(() => {
    return String(globalComponentGraphVersionPrivate.value);
});
export const incrementGlobalComponentGraphVersion = () => {
    globalComponentGraphVersionPrivate.value += 1;
};
